/**
 * Startup Adapter
 * Authority: ADAPTER AGENT (Stability V2)
 */
import { getContractDefaults } from '../contracts/render_contracts';

/** Title Case: capitalize first letter of each word */
const toTitleCase = (str) =>
    str.replace(/\b\w/g, (c) => c.toUpperCase());

export const adaptStartup = (raw) => {
    const d = getContractDefaults('Startup');
    if (!raw) return d;

    const name = toTitleCase(raw.name || d.display_name);

    return {
        ...d,
        id: raw.id || raw._id || "",
        display_name: name,
        subtitle: raw.sector || d.subtitle,
        stage_label: raw.stage || d.stage_label,
        status_key: raw.status || d.status_key,
        last_contact_label: raw.last_contact_date ? new Date(raw.last_contact_date).toLocaleDateString() : d.last_contact_label,
        avatar_initial: name.charAt(0).toUpperCase() || d.avatar_initial
    };
};
